class EmailBroadcast {
    id: number = 0;
    endereco: string = "";
    d_E_L_E_T_E: boolean = false;
    criadoEm: Date = new Date();
    excluidoEm: Date = new Date();
}

export default EmailBroadcast;
